import { Button } from "@mui/material";
import useColors from "../../api/hooks/useColors";

export default function PrimaryButton({ size = "medium", ...props }) {
  const colors = useColors();

  let fontSize, lineHeight, fontWeight, height, borderRadius;

  switch (size) {
    case "large":
      fontSize = "14px";
      lineHeight = "22px";
      fontWeight = 500;
      height = "48px";
      borderRadius = "14px";
      break;
    case "medium":
      fontSize = "14px";
      lineHeight = "22px";
      fontWeight = 500;
      height = "36px";
      borderRadius = "12px";
      break;
    case "small":
      fontSize = "12px";
      lineHeight = "18px";
      fontWeight = 500;
      height = "30px";
      borderRadius = "10px";
      break;
    case "xs":
      fontSize = "12px";
      lineHeight = "16px";
      fontWeight = 400;
      height = "24px";
      borderRadius = "8px";
      break;
    default:
      fontSize = "14px";
      lineHeight = "22px";
      fontWeight = 500;
      height = "36px";
      borderRadius = "12px";
  }

  const new_sx = {
    backgroundColor: colors.primary_main,
    color: colors.contrast_text_light + " !important",
    "&:hover": {
      backgroundColor: colors.primary_dark,
      color: colors.contrast_text_light + " !important",
      boxShadow: "none",
    },
    "&:active": {
      backgroundColor: colors.primary_dark,
      color: colors.contrast_text_light + " !important",
      boxShadow: "none",
    },
    "&:disabled": {
      backgroundColor: colors.action_disabled_bg,
      color: colors.text_disabled + " !important",
      cursor: "default",
    },
    borderRadius: borderRadius,
    boxShadow: "none",
    fontWeight: fontWeight,
    textTransform: "none",
    fontSize: fontSize,
    lineHeight: lineHeight,
    height: height,
    padding: "8px",
    fontFamily: "Poppins",
    wordWrap: "break-word",
    ...props.sx,
  };

  const new_props = { ...props, variant: "contained", sx: new_sx };

  return (
    <Button disableRipple {...new_props}>
      {props.children}
    </Button>
  );
}
